import store from 'redux/store'
import { algoliaHeaders, headers } from 'Utils/StageHandler'

/**
 * Interceptor de request para la API principal de Aludra
 */
export const setupAludraInterceptor = api => {
  api.interceptors.request.use(config => {
    const token = store.getState().login.user?.AuthenticationInfo?.Token
    const apimKey = store.getState().login?.checkCompany[0]?.APIMSubscriptionKey
    const isSearchSaleOrderWeb = window.location.pathname.includes(
      '/buscar_orden_venta_web'
    )

    const subscriptionKey = process.env.REACT_APP_SUBSCRIPTION_KEY || apimKey
    const apiKey = process.env.REACT_APP_API_KEY

    if (token && apimKey) {
      headers['app-type'] = isSearchSaleOrderWeb ? 'AB' : 'VA'
      config.headers = {
        ...config.headers,
        ...headers,
        'Api-Key': apiKey,
        'Ocp-Apim-Subscription-Key': subscriptionKey,
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      }
    }
    return config
  })
}

/**
 * Interceptor de request para Algolia
 */
export const setupAlgoliaInterceptor = api => {
  api.interceptors.request.use(config => {
    config.headers = {
      ...algoliaHeaders,
    }
    return config
  })
}

/**
 * Interceptor de request para Bus API
 */
export const setupBusInterceptor = api => {
  api.interceptors.request.use(config => {
    const apiKey = process.env.REACT_APP_API_KEY
    config.headers = {
      'Api-Key': apiKey,
    }
    return config
  })
}

/**
 * Interceptor de request para Cuart API
 */
export const setupCuartInterceptor = api => {
  api.interceptors.request.use(config => {
    const token = window.localStorage.getItem('autorizationCuart') || ''

    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: token,
      }
    }
    return config
  })
}

/**
 * Interceptor de request para Order Allocation API
 */
export const setupOaInterceptor = api => {
  api.interceptors.request.use(config => {
    const token = store.getState().login.user?.AuthenticationInfo?.Token
    const apiKey = process.env.REACT_APP_API_KEY
    const subscriptionKey = process.env.REACT_APP_SUBSCRIPTION_KEY

    if (token) {
      config.headers = {
        ...config.headers,
        'Api-Key': apiKey,
        'Ocp-Apim-Subscription-Key': subscriptionKey,
        Accept: 'application/json',
      }
    }
    return config
  })
}
